import update from "immutability-helper";
import React from "react";
import OptionalTextInput from "components/ValidatedFields/OptionalTextInput";
import { PhosphorFloppyButton } from "components/Atoms/PhosphorIconButton";

interface Props {
  file: server.dto.File
  onFileNameChanged: (newFile: server.dto.File) => void
}

const EditUploadedFile = (props: Props) => {
  const { file } = props;
  const [fileName, setFileName] = React.useState<string>(file.name);
  const [emptyNameError, setEmptyNameError] = React.useState<boolean>(false);
  const [isSaving, setIsSaving] = React.useState<boolean>(false);

  const onSave = () => {
    if (isSaving) {
      return;
    }

    setIsSaving(true);
    if (fileName.trim() === "") {
      setEmptyNameError(true);
      return;
    }

    const newFile = update(props.file, {
      name: { $set: fileName }
    });

    props.onFileNameChanged(newFile);
  };

  const onKeyPress = ({ key }: KeyboardEvent) => {
    if (key === "Enter") {
      onSave();
    }
  };

  React.useEffect(() => {
    document.addEventListener("keydown", onKeyPress, false);
    return () => { document.removeEventListener("keydown", onKeyPress, false); };
  }, [onKeyPress]);

  return <div className="padding-large flex align-center">
    <div className="grow1">
      <OptionalTextInput
        hasError={emptyNameError}
        maxLength={serverReference.constants.file.maxNameLength}
        value={fileName}
        onChange={value => {
          setFileName(value);
          setEmptyNameError(false);
        }}
      />
    </div>
    <PhosphorFloppyButton
      layout="in-square"
      onClick={onSave}
    />
  </div>;
};

export default EditUploadedFile;
